"use client";
import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  useMediaQuery,
  useTheme,
  CircularProgress,
} from "@mui/material";
import image from "../Images/GetInTouch.png";
import { CONNECT_WITH_US } from "../../../api/user";

export default function ContactForm() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    organization: "",
    designation: "",
    email: "",
    phone: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validate = () => {
    let tempErrors = {};
    tempErrors.firstName = formData.firstName ? "" : "First Name is required";
    tempErrors.lastName = formData.lastName ? "" : "Last Name is required";
    tempErrors.organization = formData.organization
      ? ""
      : "Organization is required";
    tempErrors.designation = formData.designation
      ? ""
      : "Designation is required";
    tempErrors.email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
      ? ""
      : "Enter a valid email";
    tempErrors.phone = /^\d{10}$/.test(formData.phone)
      ? ""
      : "Enter a valid 10-digit phone number";
    setErrors(tempErrors);
    return Object.values(tempErrors).every((x) => x === "");
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    setLoading(true);
    try {
      await fetch(CONNECT_WITH_US, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      setSubmitted(true);
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        width: "100%",
        margin: "0 auto",
        padding: "10px",
      }}
    >
      {/* Left - Image */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: isMobile ? "30px" : 0,
        }}
      >
        <img
          src={image}
          alt="Person working on laptop"
          style={{ width: "100%", height: "auto", borderRadius: "8px" }}
        />
      </Box>

      {/* Right - Contact Form or Thank You */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: isMobile ? "0" : "0 0 0 40px",
        }}
      >
        <Typography
          variant="h3"
          component="h2"
          sx={{
            fontWeight: "bold",
            marginBottom: "30px",
            fontSize: isMobile ? "28px" : "36px",
            textAlign: "center",
          }}
        >
          {submitted ? "Thank You!" : "Get In Touch"}
        </Typography>

        {submitted ? (
          <Typography variant="body1" align="center" sx={{ fontSize: "18px" }}>
            Your message has been sent. We’ll be in touch soon.
          </Typography>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                placeholder="First Name"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                error={!!errors.firstName}
                helperText={errors.firstName}
                variant="outlined"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "50px" } }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                placeholder="Last Name"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                error={!!errors.lastName}
                helperText={errors.lastName}
                variant="outlined"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "50px" } }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                placeholder="Your Organization"
                name="organization"
                value={formData.organization}
                onChange={handleChange}
                error={!!errors.organization}
                helperText={errors.organization}
                variant="outlined"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "50px" } }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                placeholder="Designation"
                name="designation"
                value={formData.designation}
                onChange={handleChange}
                error={!!errors.designation}
                helperText={errors.designation}
                variant="outlined"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "50px" } }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                placeholder="Mobile Number"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                error={!!errors.phone}
                helperText={errors.phone}
                variant="outlined"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "50px" } }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                placeholder="Email ID"
                name="email"
                value={formData.email}
                onChange={handleChange}
                error={!!errors.email}
                helperText={errors.email}
                variant="outlined"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "50px" } }}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                fullWidth
                variant="contained"
                onClick={handleSubmit}
                disabled={loading}
                sx={{
                  borderRadius: "50px",
                  padding: "12px",
                  backgroundColor: "#6a58c6",
                  "&:hover": { backgroundColor: "#6941a0" },
                  textTransform: "none",
                  fontSize: "16px",
                }}
              >
                {loading ? (
                  <CircularProgress size={24} sx={{ color: "#fff" }} />
                ) : (
                  "Submit"
                )}
              </Button>
            </Grid>
          </Grid>
        )}
      </Box>
    </Box>
  );
}
